import { useState } from "react";

import TrainloadContext from "./trainload-context";



const TrainloadProvider = ({ children }) => {

    const [isPassengreCount, setIsPassengerCount] = useState(true);
    const [trainloaddata, setTrainloaddata] = useState({});
    const [funnel, setFunnel] = useState({}); // store sorting functions


    const PassThroughFunnel = (newTrainloaddata, funnel) => {
        const entries = Object.entries(newTrainloaddata); // convert into array

        // for (const key of Object.keys(funnel)) {
        //     funnel[key](entries);
        // }
        // console.log(entries);

        console.log("Now Funnel: ", funnel);

        const finalSortedArray = Object.values(funnel).reduce((acc, fn) => fn(acc), entries);

        // console.log(finalSortedArray);

        const sortedObject = Object.fromEntries(finalSortedArray); //convert into object

        return sortedObject;
    }


    const trainloadContext = {
        isPassengerCount: isPassengreCount,
        trainloaddata: trainloaddata,
        funnel: funnel,
        updateTrainloadData: (newTrainloaddata) => {

            // newTrainloaddata = PassThroughFunnel(newTrainloaddata, funnel);

            setTrainloaddata({ ...newTrainloaddata });
        },
        updateIsPassengerCount: (newIsPassengerCount) => {
            setIsPassengerCount(newIsPassengerCount);
        },
        clearTrainloadData: () => {
            setTrainloaddata({});
        },
        modifyFunnel: (fn, name) => {
            // const newFun = {};
            // newFun[name] = fn;

            // remove first
            setFunnel(current => {
                // remove cost key from object
                const {[name]: _, ...rest} = current;
                console.log([name])
                return rest;
              });

            const newFun = { [name]: fn };
            // add to tail
            setFunnel(prev => ({ ...prev, ...newFun }));
        },
        clearFunnel: () => {
            setFunnel({});
        },
    };

    return (
        <TrainloadContext.Provider value={trainloadContext}>{children}</TrainloadContext.Provider>
    );
}

export default TrainloadProvider;